import React from 'react';
import { BookOpen, Twitter, Github, Linkedin } from 'lucide-react';
export const Footer = () => {
  return (
    <footer className="bg-brand-dark text-brand-parchment/70">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center space-x-3 mb-4">
              <BookOpen className="h-8 w-8 text-brand-parchment" />
              <span className="font-serif text-2xl font-bold text-brand-parchment">
                NovellaStream
              </span>
            </div>
            <p className="text-sm">
              AI-powered SaaS for generating complete, streaming novellas from a single prompt.
            </p>
          </div>
          <div>
            <h3 className="text-sm font-semibold text-brand-parchment/90 tracking-wider uppercase">Product</h3>
            <ul className="mt-4 space-y-2">
              <li><a href="#" className="text-base hover:text-brand-parchment">Features</a></li>
              <li><a href="#" className="text-base hover:text-brand-parchment">Pricing</a></li>
              <li><a href="#" className="text-base hover:text-brand-parchment">Changelog</a></li>
            </ul>
          </div>
          <div>
            <h3 className="text-sm font-semibold text-brand-parchment/90 tracking-wider uppercase">Company</h3>
            <ul className="mt-4 space-y-2">
              <li><a href="#" className="text-base hover:text-brand-parchment">About</a></li>
              <li><a href="#" className="text-base hover:text-brand-parchment">Blog</a></li>
              <li><a href="#" className="text-base hover:text-brand-parchment">Contact</a></li>
            </ul>
          </div>
          <div>
            <h3 className="text-sm font-semibold text-brand-parchment/90 tracking-wider uppercase">Legal</h3>
            <ul className="mt-4 space-y-2">
              <li><a href="/privacy-policy.md" target="_blank" rel="noopener noreferrer" className="text-base hover:text-brand-parchment">Privacy Policy</a></li>
              <li><a href="/terms-and-conditions.md" target="_blank" rel="noopener noreferrer" className="text-base hover:text-brand-parchment">Terms & Conditions</a></li>
            </ul>
          </div>
        </div>
        <div className="mt-12 border-t border-brand-parchment/20 pt-8 flex flex-col sm:flex-row items-center justify-between">
          <div className="flex space-x-6">
            <a href="#" className="hover:text-brand-parchment"><Twitter className="h-5 w-5" /></a>
            <a href="#" className="hover:text-brand-parchment"><Github className="h-5 w-5" /></a>
            <a href="#" className="hover:text-brand-parchment"><Linkedin className="h-5 w-5" /></a>
          </div>
          <p className="mt-4 sm:mt-0 text-sm">
            &copy; {new Date().getFullYear()} NovellaStream. Built with ❤️ at Cloudflare.
          </p>
        </div>
      </div>
    </footer>
  );
};